import _ from "lodash";
import { DATA_GRID_CELL_TYPES } from "../constants";
import getCheckboxValue from "./getCheckboxValue";

const getCheckboxCellProps = ({ node, cellConfig, customConfig }) => {
  const { property, negatedValue } = customConfig || {};
  const value = _.get(node, property);

  return {
    value: getCheckboxValue({ value, negatedValue }),
    cellType: DATA_GRID_CELL_TYPES.CHECKBOX,
    ...cellConfig,
  };
};

export default getCheckboxCellProps;
